module.exports = __webpack_public_path__ + "img/bg04.d6c37904.png";